var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "input-base",
    {
      attrs: {
        overlap: _vm.overlap,
        small: _vm.small,
        transparent: _vm.transparent,
        stretched: _vm.stretched,
        slimmer: _vm.slimmer
      },
      scopedSlots: _vm._u([
        {
          key: "input",
          fn: function(ref) {
            var params = ref.params
            return _c(
              "div",
              { staticClass: "rt-options-container" },
              [
                _c("input", {
                  ref: _vm.getInputName,
                  class:
                    _vm.getInnerStyle +
                    " " +
                    _vm.extraStyle +
                    " " +
                    _vm.errorStyle(params),
                  attrs: {
                    type: "text",
                    id: _vm.identification,
                    name: _vm.getInputName,
                    placeholder: _vm.getPlaceholderLabel,
                    disabled: _vm.disabled
                  },
                  domProps: { value: _vm.value },
                  on: {
                    focus: _vm.setCursorLoc,
                    keyup: _vm.setValue,
                    change: _vm.setValue
                  }
                }),
                _vm._v(" "),
                _vm.rich
                  ? _c("rt-options", { on: { insertEmoji: _vm.insertEmoji } })
                  : _vm._e()
              ],
              1
            )
          }
        }
      ])
    },
    [
      !!_vm.inputLabel
        ? _c(
            "label",
            { attrs: { slot: "label", for: _vm.getInputName }, slot: "label" },
            [_vm._v("\n\n    " + _vm._s(_vm.inputLabel) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      !!_vm.iconLeft
        ? _c("q-icon", {
            class: _vm.getIconClass,
            attrs: {
              slot: "icon-left",
              allowSelfUpdate: false,
              width: "18px",
              name: _vm.iconLeft
            },
            slot: "icon-left"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._v(" "),
      !!_vm.iconRight
        ? _c("q-icon", {
            class: _vm.getIconClass,
            attrs: {
              slot: "icon-right",
              allowSelfUpdate: false,
              width: "18px",
              name: _vm.iconRight
            },
            slot: "icon-right"
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c8f61ea0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8f61ea0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/input/InputText.vue
// module id = null
// module chunks = 